'use client';

import type { NodeViewProps } from '@tiptap/react';
import { NodeViewWrapper } from '@tiptap/react';
import 'shared-components/components/TipTap/tiptap-node/image-loading-node/image-loading-node.scss';

export const ImageLoadingNode: React.FC<NodeViewProps> = ({ node }) => {
  const { src } = node.attrs as { src: string | null };

  return (
    <NodeViewWrapper className="tiptap-image-loading" contentEditable={false}>
      {src ? (
        <div className="tiptap-image-loading-preview" aria-label="Image uploading…" aria-busy="true">
          <img src={src} alt="" className="tiptap-image-loading-img" draggable={false} />
          <div className="tiptap-image-loading-shimmer" />
        </div>
      ) : (
        <div className="tiptap-image-loading-placeholder" aria-label="Image uploading…" aria-busy="true" />
      )}
    </NodeViewWrapper>
  );
};
